<app-modal
  #deletePostModal
  [modalMessage]="deleteQuestion"
  [modalTitle]="app.text.post.modalTitle"
  (ok)="app.post.delete(post)"
></app-modal>
<app-task-completed-note
  #taskCompletedModal
  [currentTask]="post"
></app-task-completed-note>

<div>
  <!-- <div *ngIf="app.unlockedId === post._id">
  <app-post
    *ngIf="post.taskResponsible"
    [id]="post._id"
    [type]="'task'"
  ></app-post>
  <app-post
    *ngIf="post.resolveClass"
    [id]="post._id"
    [type]="'solution'"
  ></app-post>
  <app-post
    *ngIf="!post.resolveClass && !post.taskResponsible"
    [id]="post._id"
    [type]="'comment'"
  ></app-post>
</div> -->

  <div class="row m-0">
    @if (showContent) {
      <div class="col-md-12 pe-0 ps-4">
        <div class="col-md-11 col-lg-11 col-xl-11 col-sm-11 float-start">
          <div
            class="frame-post-item px-3 p-2"
            [ngClass]="{
              'frame-task-complete': post.taskCompleted,
              'frame-task-incomplete': incompleteTask,
              'frame-final-solution': finalSolution,
              'frame-solution': post.typeOfPost === 'solution'
            }"
          >
            @if (post.typeOfPost === solution) {
              <div class="px-1 mx-1 title-info">
                <b>
                  {{
                    app.field.getFieldValueAsText(
                      app.fieldId.post.resolveClass,
                      post.resolveClass
                    )
                  }}
                </b>
              </div>
            }
            @if (post.typeOfPost === comment) {
              <div class="ps-1 ms-1 title-info">
                <b>{{ post.title_comment }}</b>
              </div>
            }
            <!-- marks a comment/solution shared with the other system -->
            @if (transferInfo !== "") {
              <i
                class="transfer-marker float-end"
                [ngClass]="transferIcon"
                [title]="transferInfo"
              ></i>
            }
            <!-- Role field for comment -- used for db -->
            @if (post.responsibleRole && app.customer === "db") {
              <div class="align-field">
                <app-field
                  [model]="postModel"
                  [field]="app.fieldId.post.responsibleRole"
                  [disabled]="true"
                  [showLabel]="false"
                  [itemsInputValue]="true"
                ></app-field>
              </div>
            }
            <!-- show the next fields for solution and comment -->
            @if (post.typeOfPost !== task) {
              <div>
                <app-field
                  [field]="app.fieldId.post.content"
                  [model]="postModel"
                  [disabled]="true"
                  [itemsInputValue]="true"
                  [showLabel]="false"
                >
                </app-field>
                <div class="itemFields px-3">
                  <!-- Display fields with their values based on the lists defined in settings file -->
                  @for (
                    postField of app.post.getSolutionFieldsList(
                      post.resolveClass
                    );
                    track postField
                  ) {
                    <div>
                      @if (hasValue(postField)) {
                        <div class="row">
                          <span class="col">
                            {{ app.field.getLabel(postField) }}
                          </span>
                          @if (app.field.getType(postField) !== "options") {
                            <span
                              class="col-6"
                              [innerHtml]="
                                app.field.highlightLinks(
                                  getPostFieldValue(postField)
                                )
                              "
                              class="col-6"
                              [ngClass]="{
                                shorterLink: app.field.isLink(
                                  getPostFieldValue(postField)
                                )
                              }"
                            >
                              {{ getPostFieldValue(postField) }}
                            </span>
                          }
                          @if (app.field.getType(postField) === "options") {
                            <span class="col-6">
                              {{
                                app.field.getFieldValueAsText(
                                  postField,
                                  getPostFieldValue(postField)
                                )
                              }}
                            </span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Display values from the extraSolutionFields list -->
                @if (app.list.post.extraSolutionFields.length > 0) {
                  <div>
                    @for (
                      postField of app.list.post.extraSolutionFields;
                      track postField
                    ) {
                      <div class="itemFields px-3">
                        @if (hasValue(postField)) {
                          <div class="row">
                            <!-- Display field label -->
                            <span class="col">
                              {{ app.field.getLabel(postField) }}
                            </span>
                            <!-- Display field value as it is saved in db -->
                            <span class="col">
                              {{ getPostFieldValue(postField) }}
                            </span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- show the next fields for task -->
            @if (app.post.sectionType === stream && app.customer !== "db") {
              <div>
                @for (
                  postField of app.list.post.taskFieldsList;
                  track postField
                ) {
                  <div class="itemFields px-3">
                    @if (hasValue(postField)) {
                      <div class="row">
                        <app-field
                          [field]="postField"
                          [model]="postModel"
                          [disabled]="true"
                          [taskLabel]="true"
                          [taskInput]="true"
                          [lightOddField]="true"
                        ></app-field>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (
              app.post.sectionType === stream &&
              post.typeOfPost === task &&
              app.customer === "db"
            ) {
              <div>
                <div
                  class="task-content-db"
                  (click)="app.tasks.openTaskPanel(post)"
                >
                  <span
                    class="p-2"
                    (click)="$event.stopPropagation()"
                    [ngbTooltip]="app.text.post.markTaskCompleted"
                  >
                    @if (showCompleteIcon) {
                      <button
                        class="btn btn-sm p-0"
                        (click)="taskCompletedModal.openModal()"
                      >
                        <i class="far fa-check-circle"></i>
                      </button>
                    }
                  </span>
                  <span>{{ post.taskDescription }}</span
                  >&nbsp;&nbsp;&nbsp;
                  <span>
                    {{ app.users.getOptionName(post.taskResponsible) }}</span
                  >&nbsp;&nbsp;&nbsp;
                  @if (post.taskDueDate > 0) {
                    <span
                      [ngStyle]="
                        app.tasks.getTaskDueDateColor(
                          post.taskDueDate,
                          post.taskCompleted
                        )
                      "
                      >{{ post.taskDueDate | date: "yyyy-MM-dd" : "UTC" }}</span
                    >
                  }
                  &nbsp;&nbsp;&nbsp;
                  <span>{{ post.taskNote }}</span>
                </div>
              </div>
            }
            <div
              [ngClass]="{
                'row d-flex justify-content-between px-2':
                  app.unlockedId == null
              }"
            >
              <!-- mark task as completed -->
              @if (app.unlockedId == null && app.customer !== "db") {
                <span class="p-2">
                  <div>
                    @if (showCompleteIcon) {
                      <button
                        class="btn btn-sm btn-incomplete"
                        (click)="taskCompletedModal.openModal()"
                        [disabled]="post.cannotCloseTask"
                      >
                        <i class="fal fa-check"></i>
                        &nbsp;&nbsp;{{ app.text.post.markCompleted }}
                      </button>
                    }
                    @if (showReopenIcon) {
                      <button
                        class="btn btn-sm btn-complete"
                        (click)="
                          app.taskCompleted.changeTaskCompletion(
                            app.customer,
                            post
                          )
                        "
                      >
                        <i class="fal fa-check"></i>
                        &nbsp;&nbsp;{{ app.text.post.completed }}
                      </button>
                    }
                  </div>
                </span>
              }
              <!-- show case status for comments -->
              @if (
                post.typeOfPost === comment ||
                (post.typeOfPost === task &&
                  app.customer !== "db" &&
                  app.permission.post.seeRoles)
              ) {
                <div class="bottom-info">
                  <div class="solution-name">
                    <span
                      class="badge selected pull-right"
                      [ngClass]="{
                        'badge-color': app.permission.post.seeRoles
                      }"
                    >
                      {{ threadStatus }}
                    </span>
                  </div>
                </div>
              }
            </div>
            <div
              [ngClass]="{
                'row d-flex justify-content-between ps-4':
                  app.unlockedId == null && showFinalSolutionCheckbox
              }"
            >
              <!-- show final solution checkbox only for the clients which have the permission and for comments, solutions -->
              @if (app.unlockedId == null && showFinalSolutionCheckbox) {
                <div>
                  <app-field
                    [model]="postModel"
                    [field]="app.fieldId.post.acceptedSolution"
                    (click)="app.post.setFinalSolution(post)"
                    [isFinalSolutin]="true"
                    [lightOddField]="true"
                  >
                  </app-field>
                </div>
              }
              <!-- show case status for solutions -->
              @if (post.typeOfPost === solution) {
                <div class="bottom-info">
                  @if (showGraphicsButton) {
                    <div class="stock-graphic">
                      <app-stock-graphic-modal></app-stock-graphic-modal>
                    </div>
                  }
                  <div class="solution-name">
                    <span class="float-end me-1">
                      <span
                        class="badge selected"
                        [ngClass]="{
                          'badge-color': app.permission.post.seeRoles
                        }"
                      >
                        {{ threadStatus }}
                      </span>
                    </span>
                  </div>
                </div>
              }
            </div>
            @if (app.unlockedId === null) {
              <app-attachments
                [id]="post._id"
                type="post"
                [editPermission]="app.post.hasEditPermission(post)"
                [files]="post._attachments"
                [filesDetails]="post.attachmentHistory"
              ></app-attachments>
            }
          </div>
          <!-- task completed credtis -->
          @if (post.taskCompleted && completedBy && app.customer !== "db") {
            <div class="taskCompleted pull-right">
              {{ app.text.credits.completed }} {{ app.text.credits.by }}
              <app-user-link
                [name]="completedBy"
                [type]="'post'"
              ></app-user-link>
              {{ app.text.credits.on }}
              {{ completedAt }}
            </div>
          }
          @if (post.typeOfPost !== task || app.customer !== "db") {
            <div class="float-end clear">
              @if (post != null) {
                <app-credits
                  class="me-1 mb-2"
                  type="post"
                  [inputDoc]="post"
                  [isCreated]="true"
                >
                </app-credits>
              }
              <div class="float-end">
                @if (post != null) {
                  <app-credits
                    class="credits"
                    type="post"
                    [inputDoc]="post"
                    [isEdited]="true"
                  ></app-credits>
                }
              </div>
            </div>
          }
        </div>
        <!-- show controls -->
        <div class="col-md-1 col-lg-1 col-xl-1 col-sm-1 float-end ps-2 pe-2">
          @if (app.unlockedId === null) {
            <div>
              <app-unlock
                [id]="post._id"
                [permission]="canEditCurrentPost"
                [hasText]="false"
                (unlock)="preparePostForEditMode()"
                [title]="app.text.post.edit"
              >
              </app-unlock>
              @if (hasPermissionToAddAttachment()) {
                <app-attachments-controls
                  [id]="post._id"
                  type="post"
                ></app-attachments-controls>
              }
              <div>
                @if (canEditCurrentPost) {
                  <button
                    class="btn m-0"
                    (click)="
                      getDeleteQuestionText(post); deletePostModal.open()
                    "
                    [title]="app.text.post.delete"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                }
              </div>
              <!-- show the sync button only for comments/solutions -->
              @if (!post.taskResponsible) {
                <app-sync
                  [displayPostSync]="true"
                  [id]="post._id"
                  type="post"
                  [disabled]="app.unlockedId != null"
                  [hasText]="false"
                ></app-sync>
              }
              <!-- show the transfer button only for comments/solutions -->
              @if (!post.taskResponsible) {
                <app-transfer
                  [id]="post._id"
                  [post]="post"
                  type="post"
                  [hasText]="false"
                ></app-transfer>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
